import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "rounded-md bg-white p-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-1" }, "Sort by", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "border-none h-[1px] bg-gray-200 my-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mb-1" }, "Order by", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", { class: "border-none h-[1px] bg-gray-200 my-2" }, null, -1)

import { Button, Dropdown, Radio, RadioGroup } from 'ant-design-vue';
import { onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { OrderOption, SortOption } from '@/model/dropdown';
import { SortSequence } from '@/model/universal';


export default /*#__PURE__*/_defineComponent({
  __name: 'SortDropdown',
  props: {
    sortOptions: {},
    orderOptions: {},
    defaultSortBy: {},
    defaultOrderBy: {}
  },
  emits: ["sort", "change"],
  setup(__props: any, { emit }) {

const props = __props;





onMounted(() => emit('sort', `${activeSortBy.value} ${activeOrderBy.value}`));

function reset(isDelay = true) {
	setTimeout(
		() => {
			selectedSortBy.value = activeSortBy.value;
			selectedOrderBy.value = activeOrderBy.value;
		},
		isDelay ? 150 : 0
	);
}

function sort() {
	openDropdown.value = false;
	activeSortBy.value = selectedSortBy.value;
	activeOrderBy.value = selectedOrderBy.value;
	emit('sort', `${activeSortBy.value} ${activeOrderBy.value}`);
	emit('change', `${activeSortBy.value} ${activeOrderBy.value}`);
}

const route = useRoute();
const selectedSortBy = ref<string>(
	props.sortOptions.find(
		(sort) => sort.label.toLowerCase() === route.query.sort?.toString().toLowerCase()
	)?.value ||
		props.defaultSortBy ||
		(props.sortOptions.length > 0 ? props.sortOptions[0].value : '')
);
const selectedOrderBy = ref<string>(
	route.query.order &&
		props.orderOptions.map((opt) => opt.value.toString()).includes(route.query.order.toString())
		? route.query.order.toString()
		: props.defaultOrderBy ||
				(props.orderOptions.length > 0 ? props.orderOptions[0].value : SortSequence.Ascending)
);
const activeSortBy = ref<string>(selectedSortBy.value);
const activeOrderBy = ref<string>(selectedOrderBy.value);

const openDropdown = ref(false);

watch(openDropdown, (isOpen) => !isOpen && reset());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dropdown), {
    onOpenChange: _cache[3] || (_cache[3] = (e) => (openDropdown.value = e)),
    open: openDropdown.value
  }, {
    overlay: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_unref(RadioGroup), {
          value: selectedSortBy.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedSortBy).value = $event)),
          class: "flex flex-col"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortOptions, (sort, index) => {
              return (_openBlock(), _createBlock(_unref(Radio), {
                key: index,
                value: sort.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(sort.label), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value"]),
        _hoisted_3,
        _hoisted_4,
        _createVNode(_unref(RadioGroup), {
          value: selectedOrderBy.value,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((selectedOrderBy).value = $event)),
          class: "flex flex-col"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderOptions, (order, index) => {
              return (_openBlock(), _createBlock(_unref(Radio), {
                key: index,
                value: order.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(order.label(selectedSortBy.value)), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value"]),
        _hoisted_5,
        _createVNode(_unref(Button), {
          class: "mr-2",
          onClick: _cache[2] || (_cache[2] = () => reset(false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Reset")
          ]),
          _: 1
        }),
        _createVNode(_unref(Button), {
          type: "primary",
          onClick: sort
        }, {
          default: _withCtx(() => [
            _createTextVNode("Submit")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Button), null, {
        default: _withCtx(() => [
          _createTextVNode(" Sort ")
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})